import React from 'react';

interface DevelopmentIconProps {
  className?: string;
}

const DevelopmentIcon: React.FC<DevelopmentIconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
    >
      <path d="m3 5.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5zm5.5 1.5c.828 0 1.5-.672 1.5-1.5s-.672-1.5-1.5-1.5-1.5.672-1.5 1.5.672 1.5 1.5 1.5zm15.5-1v12c0 2.757-2.243 5-5 5h-14c-2.757 0-5-2.243-5-5v-12c0-2.757 2.243-5 5-5h14c2.757 0 5 2.243 5 5zm-22 0v2h20v-2c0-1.654-1.346-3-3-3h-14c-1.654 0-3 1.346-3 3zm20 12v-8h-20v8c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3zm-11.793-4.793c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-2.181 2.181c-.872.872-.872 2.29.019 3.18l2.181 2.071c.399.381 1.033.365 1.413-.036.381-.4.364-1.033-.036-1.413l-2.162-2.054c-.092-.092-.092-.242 0-.334l2.181-2.181zm5-1.414c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l2.181 2.181c.092.092.092.242.011.323l-2.159 2.093c-.396.384-.406 1.018-.021 1.414.385.397 1.018.406 1.414.021l2.17-2.104c.872-.872.872-2.29 0-3.162l-2.181-2.181z"/>
    </svg>
  );
};

export default DevelopmentIcon;
